var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-10 1",
    clipPath: "url(#clip0_1122_22640)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 73213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1161",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FEDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1162",
    d: "M10.0001 17.3532C14.0612 17.3532 17.3534 14.061 17.3534 9.99982C17.3534 5.93868 14.0612 2.64648 10.0001 2.64648C5.93893 2.64648 2.64673 5.93868 2.64673 9.99982C2.64673 14.061 5.93893 17.3532 10.0001 17.3532Z",
    fill: "#FCAA17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 60219",
    d: "M9.999 4.34961L11.6712 7.7385L15.4101 8.28183L12.7046 10.9196L13.3434 14.6441L9.999 12.8863L6.65456 14.6474L7.29345 10.9229L4.58789 8.28516L8.32678 7.74183L9.999 4.34961Z",
    fill: "#FEDA2C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1122_22640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.55524f459498016ae6cb4192c3ab25d2.svg";
export { ForwardRef as ReactComponent };